module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAUCAYAAACeXl35AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAF5AAABeQBCVGUlAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAEZSURBVEiJ7Za9SgNBFEbP3UYULSIWNipib1LbWUT7vImC7yCIWmqlraC1uC5YaR+wsFFSxB92E5VsTDZDimuxEUJkLGSmEb/2FIeBy2EEQFXngX2gnPbNVBjX2Khe8ZS1cT0ZyKpAYRg0TUYxOuI5+3AqDIC9URnAzNg4O8urTmVfwjUbXJ9d9CK0TtW5jwAIbTCMa86Foqpz5EczPQwapkvx8piXnuOjEZE6UALOgLTVN5zU7yhF7mX/+xsTAFVdYNDSjmHy5gG2LyBOnfsSa0vfu1A5gMRtv5OA/GXfWlqYgC1r9H6/ACjb4MqSH6G1mB5S+nNLr+/9CDeB11Hw1oHdyINQRB7JW3oKtNo9OL+FyiE03P8w+ATF4WHM4gDP9gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/Assets/logo-psflex.png
// module id = tdco
// module chunks = 1